import axios from 'axios';

// Relativo: en prod CloudFront enruta /api/* al EC2 (mismo dominio HTTPS); en dev usa el proxy.
export const API_URL = process.env.REACT_APP_API_URL || '/api';

export const api = axios.create({ baseURL: API_URL });
/** Clave de localStorage con el id del agente seleccionado en el panel. */
export const CLAVE_AGENTE = 'respondo_agente';

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('respondo_token');
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  // Agente elegido en la barra superior (cada agente tiene su número, prompt y agenda).
  const agente = localStorage.getItem(CLAVE_AGENTE);
  if (agente) {
    config.headers = config.headers || {};
    (config.headers as any)['X-Agente-Id'] = agente;
  }
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('respondo_token');
      const publicas = ['/login', '/registro', '/recuperar-contrasena', '/restablecer-contrasena'];
      if (!publicas.some((p) => window.location.pathname.startsWith(p))) {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  },
);
